import { fromJS } from 'immutable';
import ACTIONS from '../app.constants';
import { AuthenticationActionTypes } from '../modules/authentication/types';

export default function siteReducer(state = fromJS({ context: {} }), action: AuthenticationActionTypes) {
    switch (action.type) {
        case ACTIONS.USER_AUTHENTICATED:
            return state.setIn(['context'], action.payload);
    }

    return state;
}
